import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const selectInternoAndamentos = (state: RootState) =>
  state.chatAtendimentoProcessoInterno.andamentos;

export const selectInternoPendencias = (state: RootState) =>
  state.chatAtendimentoProcessoInterno.pendencias;

export const selectInternoPendenciasFiltro = (state: RootState) =>
  state.chatAtendimentoProcessoInterno.pendenciasFiltro;

export const selectInternoPendenciasContagem = (state: RootState) =>
  state.chatAtendimentoProcessoInterno.pendenciasContagem;

export const selectIsLoadingInternoAndamentos = (state: RootState) =>
  state.chatAtendimentoProcessoInterno.isLoadingAndamentos;

export const selectIsLoadingInternoPendencias = (state: RootState) =>
  state.chatAtendimentoProcessoInterno.isLoadingPendencias;

export const selectInternoAndamentosError = (state: RootState) =>
  state.chatAtendimentoProcessoInterno.errorAndamentos;

export const selectInternoPendenciasError = (state: RootState) =>
  state.chatAtendimentoProcessoInterno.errorPendencias;

export const selectInternoIsMutating = (state: RootState) =>
  state.chatAtendimentoProcessoInterno.isMutating;

export const selectMensagensComAndamento = createSelector(
  [selectInternoAndamentos],
  (andamentos) => {
    const ids = new Set<string>();
    for (const andamento of andamentos) {
      if (andamento.chatMensagemId) ids.add(andamento.chatMensagemId);
    }
    return ids;
  },
);
